module.exports = __webpack_public_path__ + "img/activity-water.da9356ef.svg";